import axios from 'axios';
import { API_BASE_URL } from '../api';

/**
 * Analyze fabric image using AI and generate search embeddings (metadata + image).
 * @param {string} imageUrl - URL of the fabric image to analyze
 * @param {Object} [productMetadata] - Optional fields included in metadata embedding (name, description, category, tags, …)
 * @returns {Promise<Object>} - Response with data.analysis, data.search (embeddings), etc.
 */
export const analyzeFabric = async (imageUrl, productMetadata = {}) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };

  const payload = {
    imageUrl,
    ...(productMetadata && typeof productMetadata === 'object' ? productMetadata : {})
  };

  console.log('Fabric Analysis API: imageUrl + optional metadata fields');

  try {
    const response = await axios.post(`${API_BASE_URL}/fabric-analysis`, payload, { 
      headers,
      timeout: 240000 // vision analysis + visual query + text embeddings
    });
    return response.data;
  } catch (error) {
    console.error('Fabric Analysis API error:', error);
    
    // Handle timeout errors specifically
    if (error.code === 'ECONNABORTED') {
      throw new Error('Fabric analysis timed out. Please try again.');
    }
    
    // Handle API errors
    if (error.response) {
      throw new Error(error.response.data?.message || 'Failed to analyze fabric');
    }
    
    throw error;
  }
};

